import { userRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { CreateUserRequest } from "./create-user/CreateUserRequest";
import { CreateUserResponse } from "./create-user/CreateUserResponse";

export const useCreateUser = () =>
  useRestResourceHook<CreateUserRequest, CreateUserResponse>((request) =>
    userRestResource.createUser(request),
  );
